import { Skeleton } from "@/components/ui/skeleton";

/**
 * Vises mens vi sjekker om instansen er satt opp. Formen speiler innloggingen
 * (logo, overskrift, kort), så siden ikke hopper når innholdet lander.
 */
export const LoginSkeleton = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-5 py-12">
      <div className="w-full max-w-100">
        <div className="flex flex-col items-center">
          <Skeleton className="size-14 rounded-2xl" />
          <Skeleton className="mt-6 h-8 w-56" />
          <Skeleton className="mt-3 h-4 w-64" />
        </div>
        <div className="mt-8 space-y-5 rounded-2xl border bg-card p-6 sm:p-8">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
        </div>
      </div>
    </div>
  );
};
